import React from 'react';
import moment from 'moment';
import Sscaller from '../config/Sscaller';
import AppHelper from '../coreComponent/AppHelper';
import ReportContainer from './ReportContainer';
import axios from 'axios';

export default class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A'),
      data: null,
      personId: null,
      docType: null,
      selfieUrl: null,
      personName: null,
      fathersName: null,
      address: null,
      noOfCases: null,
      cases: [],
      details: {},
      matchedInformation: {},
      verfiedStatus: null,
      isFaceMatched: null,
      isInfoUnavailable: null,
      isMisMatch: null,
      isIdMismatch: null,
      document1: null,
      document2: null,
      isData: null,
      isPdf: null,
      location: window.location.href,
      loading1: true,
      loading2: true,
      selfieLoading: true,
      error: false
    };
  }

  componentDidMount() {
    this.setState(
      {
        personId: this.state.location.split('/')[this.state.location.split('/').length - 2],
        docType: this.state.location.split('/')[this.state.location.split('/').length - 1]
      },
      () => {
        this.LoadData();
      }
    );
  }

  LoadData = () => {
    let url;
    let me = this;
    if (me.state.docType === 'courtCheck') {
      url = `criminal/courtCheck/${me.state.personId}`;
    } else {
      url = `user/getPersonPublicApi/${me.state.personId}`;
    }

    Sscaller({
      method: 'get',
      url: url,
      headers: {
        token: AppHelper.getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        me.setState(
          {
            data: response.data
          },
          () => {
            me.state.data;
            if (me.state.docType === 'courtCheck') {
              me.setCriminalData();
            } else {
              me.setData();
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isData: false,
          date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
        });
      });
  };

  setCriminalData = () => {
    if (this.state.data !== null) {
      let data = this.state.data;
      let date = moment(data.createdAt).utcOffset('+05:30').format('D MMM YYYY, hh:mm A');
      let personName = `${
        data.query === undefined || data.query === null
          ? null
          : data.query.name === undefined || data.query.name === null
          ? null
          : data.query.name
      }`;
      let fathersName = `${
        data.query === undefined || data.query === null
          ? null
          : data.query.fatherName === undefined || data.query.fatherName === null
          ? null
          : data.query.fatherName
      }`;
      let address = `${
        data.query === undefined || data.query === null
          ? null
          : data.query.address === undefined || data.query.address === null
          ? null
          : data.query.address
      }`;
      let noOfCases = data.reports.length;
      let cases = data.reports.map((value) => {
        value = {
          name: `${value.name === undefined || value.name === null ? null : value.name}`,
          id: `${value.cnr === undefined || value.cnr === null ? null : value.cnr}`,
          address: `${
            value.address === undefined || value.address === null || value.address === ''
              ? value.raw_address === undefined ||
                value.raw_address === null ||
                value.address === ''
                ? null
                : value.raw_address
              : value.address
          }`,
          link: `${value.link === undefined || value.link === null ? null : value.link}`
        };
        return { ...value };
      });
      this.setState({
        isData: true,
        date: date,
        personName: personName,
        fathersName: fathersName,
        address: address,
        noOfCases: noOfCases,
        cases: cases,
        loading1: false,
        loading2: false,
        selfieLoading: false
      });
    } else {
      this.setState({
        isData: false,
        date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
      });
    }
  };

  setData = () => {
    if (this.state.data !== null && this.state.data.person) {
      let documentType = this.state.docType;
      let data = this.state.data.person;
      let date = moment(data.createdAt).utcOffset('+05:30').format('D MMM YYYY, hh:mm A');
      let personName = `${
        data.name
          ? data.name.first
            ? data.name.first +
              ' ' +
              `${
                data.name.middle
                  ? `${
                      data.name.last
                        ? `${
                            data.name.middle === data.name.last
                              ? data.name.middle
                              : data.name.middle + ' ' + data.name.last
                          }`
                        : data.name.middle
                    }`
                  : `${data.name.last ? data.name.last : ''}`
              }`
            : ''
          : ''
      }`;
      let selfieUrl =
        data.selfie !== undefined && data.selfie.url !== null ? data.selfie.url : null;
      let docType = `${
        documentType === 'ind_aadhaar'
          ? 'Aadhaar Card'
          : `${
              documentType === 'ind_pan'
                ? 'PAN Card'
                : `${
                    documentType === 'ind_driving_license'
                      ? "Driver's License"
                      : `${documentType === 'ind_voter_id' ? 'Voter ID' : this.state.docType}`
                  }`
            }`
      }`;
      this.setState({
        isData: true,
        date: date,
        personName: personName,
        docType: docType
      });
      this.setDetails(docType, data, personName);
      this.setSelfieUrl(selfieUrl);
    } else {
      this.setState({
        isData: false,
        date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
      });
    }
  };

  setDetails = (docType, data, personName) => {
    switch (docType) {
      case 'Aadhaar Card': {
        let details = data.documents.ind_aadhaar;
        if (
          (details && details.result) ||
          (details && details.govResult && details.govResult.verified_data)
        ) {
          let isFaceMatched = `${details.faceMatched ? true : details.matchResult ? true : false}`;
          let result = details.result;
          let govDetails = details.govResult && JSON.parse(details.govResult.verified_data);
          let detailsInformation = {
            faceMatch: `${
              isFaceMatched === 'true'
                ? details.matchResult
                  ? details.matchResult.match_score > 90
                    ? 'Perfect'
                    : details.matchResult.match_score > 70
                    ? 'Almost'
                    : details.matchResult.match_score > 40
                    ? 'Barely'
                    : 'Failed'
                  : 'Failed'
                : null
            }`,
            aadhaarNumber: `${
              result
                ? result.id_number
                  ? result.id_number
                  : govDetails
                  ? govDetails.document_id
                    ? govDetails.document_id
                    : null
                  : null
                : govDetails
                ? govDetails.document_id
                  ? govDetails.document_id
                  : null
                : null
            }`,

            name: `${
              result
                ? result.name_on_card
                  ? result.name_on_card
                  : govDetails
                  ? govDetails.name
                    ? govDetails.name
                    : null
                  : null
                : govDetails
                ? govDetails.name
                  ? govDetails.name
                  : null
                : null
            }`,

            dateOfBirth: `${
              result
                ? result.date_of_birth
                  ? result.date_of_birth
                  : govDetails
                  ? govDetails.dob
                    ? govDetails.dob
                    : null
                  : null
                : govDetails
                ? govDetails.dob
                  ? govDetails.dob
                  : null
                : null
            }`,

            age: `${govDetails ? (govDetails['Age Band'] ? govDetails['Age Band'] : null) : null}`,

            gender: `${
              result
                ? result.gender
                  ? result.gender
                  : govDetails
                  ? govDetails.Gender
                    ? govDetails.Gender
                    : null
                  : null
                : govDetails
                ? govDetails.Gender
                  ? govDetails.Gender
                  : null
                : null
            }`,

            fathersName: `${
              result
                ? result.fathers_name
                  ? result.fathers_name
                  : govDetails
                  ? govDetails.co
                    ? govDetails.co
                    : null
                  : null
                : govDetails
                ? govDetails.co
                  ? govDetails.co
                  : null
                : null
            }`,

            district: `${
              result
                ? result.district
                  ? result.district
                  : govDetails
                  ? govDetails.dist
                    ? govDetails.dist
                    : null
                  : null
                : govDetails
                ? govDetails.dist
                  ? govDetails.dist
                  : null
                : null
            }`,

            state: `${
              result
                ? result.state
                  ? result.state
                  : govDetails
                  ? govDetails.State
                    ? govDetails.State
                    : null
                  : null
                : govDetails
                ? govDetails.State
                  ? govDetails.State
                  : null
                : null
            }`,

            address: `${
              result
                ? result.address
                  ? result.address
                  : govDetails
                  ? govDetails.address
                    ? govDetails.address
                    : null
                  : null
                : govDetails
                ? govDetails.address
                  ? govDetails.address
                  : null
                : null
            }`,

            pincode: `${
              result
                ? result.pincode
                  ? result.pincode
                  : govDetails
                  ? govDetails.pc
                    ? govDetails.pc
                    : null
                  : null
                : govDetails
                ? govDetails.pc
                  ? govDetails.pc
                  : null
                : null
            }`,

            mobileNumber: `${
              govDetails ? (govDetails['Mobile Number'] ? govDetails['Mobile Number'] : null) : null
            }`
          };
          let matchedInformation = {
            aadhaarNumber: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.id_match !== null &&
                    details.matchedInformation.id_match !== undefined
                    ? details.matchedInformation.id_match
                    : null
                  : null
                : true
            }`,

            name: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.name_match !== null &&
                    details.matchedInformation.name_match !== undefined
                    ? details.matchedInformation.name_match
                    : null
                  : null
                : true
            }`,

            dateOfBirth: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.dob_match !== null &&
                    details.matchedInformation.dob_match !== undefined
                    ? details.matchedInformation.dob_match
                    : null
                  : null
                : true
            }`,

            age: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.age_match !== null &&
                    details.matchedInformation.age_match !== undefined
                    ? details.matchedInformation.age_match
                    : govDetails
                    ? govDetails.State
                      ? true
                      : null
                    : null
                  : null
                : true
            }`,

            gender: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.gender_match !== null &&
                    details.matchedInformation.gender_match !== undefined
                    ? details.matchedInformation.gender_match
                    : null
                  : null
                : true
            }`,

            fathersName: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.father_name_match !== null &&
                    details.matchedInformation.father_name_match !== undefined
                    ? details.matchedInformation.father_name_match
                    : null
                  : null
                : true
            }`,

            district: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.district_match !== null &&
                    details.matchedInformation.district_match !== undefined
                    ? details.matchedInformation.district_match
                    : null
                  : null
                : true
            }`,

            state: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.state_match !== null &&
                    details.matchedInformation.state_match !== undefined
                    ? details.matchedInformation.state_match
                    : null
                  : null
                : true
            }`,

            address: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.address_match !== null &&
                    details.matchedInformation.address_match !== undefined
                    ? details.matchedInformation.address_match
                    : null
                  : null
                : true
            }`,

            pincode: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.pincode_match !== null &&
                    details.matchedInformation.pincode_match !== undefined
                    ? details.matchedInformation.pincode_match
                    : null
                  : null
                : true
            }`,

            mobileNumber: `${
              details.result
                ? details.matchedInformation
                  ? details.matchedInformation.id_match !== null &&
                    details.matchedInformation.id_match !== undefined
                    ? details.matchedInformation.id_match
                    : null
                  : null
                : true
            }`
          };
          this.setState({
            error: details.matchedInformation
              ? details.matchedInformation.message
                ? details.matchedInformation.message.toLowerCase().includes('error')
                  ? details.matchedInformation.message
                  : false
                : false
              : false,
            details: detailsInformation,
            matchedInformation: matchedInformation,
            isFaceMatched: isFaceMatched
          });
          this.setStatus(docType, detailsInformation, govDetails, matchedInformation);
          this.setPersonName(personName, detailsInformation);
          this.setDocuments(details.document1, details.document2);
        } else {
          this.setState({
            isData: false,
            date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
          });
        }
        break;
      }
      case 'PAN Card': {
        let details = data.documents.ind_pan;
        if (details && details.result) {
          let isFaceMatched = `${details.faceMatched ? true : details.matchResult ? true : false}`;
          let govDetails = details.govResult;
          let detailsInformation = {
            faceMatch: `${
              isFaceMatched === 'true'
                ? details.matchResult
                  ? details.matchResult.match_score > 90
                    ? 'Perfect'
                    : details.matchResult.match_score > 70
                    ? 'Almost'
                    : details.matchResult.match_score > 40
                    ? 'Barely'
                    : 'Failed'
                  : 'Failed'
                : null
            }`,
            panNumber: `${details.result.id_number ? details.result.id_number : null}`,

            name: `${details.result.name_on_card ? details.result.name_on_card : null}`,

            dateOfBirth: `${details.result.date_of_birth ? details.result.date_of_birth : null}`,

            age: `${details.result.age ? details.result.age : null}`,

            fathersName: `${details.result.fathers_name ? details.result.fathers_name : null}`,

            panType: `${details.result.pan_type ? details.result.pan_type : null}`
          };
          let matchedInformation = {
            panNumber: `${
              details.result.id_number
                ? details.matchedInformation
                  ? details.matchedInformation.id_match !== null &&
                    details.matchedInformation.id_match !== undefined
                    ? details.matchedInformation.id_match
                    : null
                  : null
                : null
            }`,

            name: `${
              details.result.name_on_card
                ? details.matchedInformation
                  ? details.matchedInformation.name_match !== null &&
                    details.matchedInformation.name_match !== undefined
                    ? details.matchedInformation.name_match > 95
                    : null
                  : null
                : null
            }`,

            dateOfBirth: `${
              details.result.date_of_birth
                ? details.matchedInformation
                  ? details.matchedInformation.dob_match !== null &&
                    details.matchedInformation.dob_match !== undefined
                    ? details.matchedInformation.dob_match
                    : null
                  : null
                : null
            }`,

            age: `${null}`,

            fathersName: `${null}`,

            panType: `${null}`
          };
          this.setState({
            error: details.matchedInformation
              ? details.matchedInformation.message
                ? details.matchedInformation.message.toLowerCase().includes('error')
                  ? details.matchedInformation.message
                  : false
                : false
              : false,
            details: detailsInformation,
            matchedInformation: matchedInformation,
            isFaceMatched: isFaceMatched
          });
          this.setStatus(docType, detailsInformation, govDetails, matchedInformation);
          this.setPersonName(personName, detailsInformation);
          this.setDocuments(details.document1, details.document2);
        } else {
          this.setState({
            isData: false,
            date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
          });
        }
        break;
      }
      case "Driver's License": {
        let details = data.documents.ind_driving_license;
        if (details && details.result) {
          let isFaceMatched = `${details.faceMatched ? true : details.matchResult ? true : false}`;
          let govDetails = details.govResult
            ? details.govResult.result
              ? details.govResult.result.source_output
              : {}
            : {};
          let detailsInformation = {
            faceMatch: `${
              isFaceMatched === 'true'
                ? details.matchResult
                  ? details.matchResult.match_score > 90
                    ? 'Perfect'
                    : details.matchResult.match_score > 70
                    ? 'Almost'
                    : details.matchResult.match_score > 40
                    ? 'Barely'
                    : 'Failed'
                  : 'Failed'
                : null
            }`,
            dlNumber: `${
              govDetails.id_number
                ? govDetails.id_number
                : `${details.result.id_number ? details.result.id_number : null}`
            }`,

            name: `${
              govDetails.name
                ? govDetails.name
                : `${details.result.name_on_card ? details.result.name_on_card : null}`
            }`,

            dateOfBirth: `${
              govDetails.dob
                ? govDetails.dob
                : `${details.result.date_of_birth ? details.result.date_of_birth : null}`
            }`,

            fathersName: `${
              govDetails.relatives_name
                ? govDetails.relatives_name
                : `${details.result.fathers_name ? details.result.fathers_name : null}`
            }`,

            rto: `${govDetails.issuing_rto_name ? govDetails.issuing_rto_name : null}`,

            validFrom: `${
              govDetails.nt_validity_from
                ? govDetails.nt_validity_from
                : `${
                    details.result.validity
                      ? details.result.validity.NT
                        ? details.result.validity.NT
                        : null
                      : null
                  }`
            }`,

            validTill: `${
              govDetails.nt_validity_to
                ? govDetails.nt_validity_to
                : `${
                    details.result.validity
                      ? details.result.validity.T
                        ? details.result.validity.T
                        : null
                      : null
                  }`
            }`,

            vehicleClass: `${
              govDetails.cov_details
                ? govDetails.cov_details.map((value) => {
                    if (value.cov) {
                      return value.cov;
                    }
                  })
                : `${details.result.type ? details.result.type : null}`
            }`,

            gender: `${govDetails.gender ? govDetails.gender : null}`,

            address: `${
              govDetails.permanent_address
                ? govDetails.permanent_address
                : `${details.result.address ? details.result.address : null}`
            }`,

            status: `${
              govDetails.dl_status
                ? govDetails.dl_status
                : `${
                    details.matchedInformation
                      ? details.matchedInformation.dl_status
                        ? details.matchedInformation.dl_status
                        : null
                      : null
                  }`
            }`
          };
          let matchedInformation = {
            dlNumber: `${
              details.result.id_number
                ? details.matchedInformation
                  ? details.matchedInformation.ocr_id_match !== null &&
                    details.matchedInformation.ocr_id_match !== undefined
                    ? details.matchedInformation.ocr_id_match
                    : govDetails.id_number
                    ? true
                    : null
                  : govDetails.id_number
                  ? true
                  : null
                : govDetails.id_number
                ? true
                : null
            }`,

            name: `${
              details.result.name_on_card
                ? details.matchedInformation
                  ? details.matchedInformation.name_match !== null &&
                    details.matchedInformation.name_match !== undefined
                    ? details.matchedInformation.name_match > 95
                    : govDetails.name
                    ? true
                    : null
                  : govDetails.name
                  ? true
                  : null
                : govDetails.name
                ? true
                : null
            }`,

            dateOfBirth: `${
              details.result.date_of_birth
                ? details.matchedInformation
                  ? details.matchedInformation.dob_match !== null &&
                    details.matchedInformation.dob_match !== undefined
                    ? details.matchedInformation.dob_match
                    : govDetails.dob
                    ? true
                    : null
                  : govDetails.dob
                  ? true
                  : null
                : govDetails.dob
                ? true
                : null
            }`,

            fathersName: `${
              details.result.fathers_name
                ? details.matchedInformation
                  ? details.matchedInformation.father_name_match !== null &&
                    details.matchedInformation.father_name_match !== undefined
                    ? details.matchedInformation.father_name_match > 95
                    : govDetails.relatives_name
                    ? true
                    : null
                  : govDetails.relatives_name
                  ? true
                  : null
                : govDetails.relatives_name
                ? true
                : null
            }`,

            rto: `${govDetails.issuing_rto_name ? true : null}`,

            validFrom: `${govDetails.nt_validity_from ? true : null}`,

            validTill: `${govDetails.nt_validity_to ? true : null}`,

            vehicleClass: `${govDetails.cov_details ? true : null}`,

            gender: `${govDetails.gender ? true : null}`,

            address: `${
              details.result.address
                ? details.matchedInformation
                  ? details.matchedInformation.street_address_match !== null &&
                    details.matchedInformation.street_address_match !== undefined
                    ? details.matchedInformation.street_address_match > 75
                    : govDetails.permanent_address
                    ? true
                    : null
                  : govDetails.permanent_address
                  ? true
                  : null
                : govDetails.permanent_address
                ? true
                : null
            }`,

            status: `${
              details.matchedInformation
                ? details.matchedInformation.dl_status !== null &&
                  details.matchedInformation.dl_status !== undefined
                  ? true
                  : govDetails.dl_status
                  ? true
                  : null
                : govDetails.dl_status
                ? true
                : null
            }`
          };
          this.setState({
            error: details.matchedInformation
              ? details.matchedInformation.message
                ? details.matchedInformation.message.toLowerCase().includes('error')
                  ? details.matchedInformation.message
                  : false
                : false
              : false,
            details: detailsInformation,
            matchedInformation: matchedInformation,
            isFaceMatched: isFaceMatched
          });
          this.setStatus(docType, detailsInformation, govDetails, matchedInformation);
          this.setPersonName(personName, detailsInformation);
          this.setDocuments(details.document1, details.document2);
        } else {
          this.setState({
            isData: false,
            date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
          });
        }
        break;
      }
      case 'Voter ID': {
        let details = data.documents.ind_voter_id;
        if (details && details.result) {
          let isFaceMatched = `${details.faceMatched ? true : details.matchResult ? true : false}`;
          let govDetails = details.govResult
            ? details.govResult.result
              ? details.govResult.result.source_output
              : {}
            : {};
          let detailsInformation = {
            faceMatch: `${
              isFaceMatched === 'true'
                ? details.matchResult
                  ? details.matchResult.match_score > 90
                    ? 'Perfect'
                    : details.matchResult.match_score > 70
                    ? 'Almost'
                    : details.matchResult.match_score > 40
                    ? 'Barely'
                    : 'Failed'
                  : 'Failed'
                : null
            }`,
            voterNumber: `${
              govDetails.id_number
                ? govDetails.id_number
                : `${details.result.id_number ? details.result.id_number : null}`
            }`,

            name: `${
              govDetails.name_on_card
                ? govDetails.name_on_card
                : `${details.result.name_on_card ? details.result.name_on_card : null}`
            }`,

            dateOfBirth: `${
              govDetails.dob
                ? govDetails.dob
                : `${details.result.date_of_birth ? details.result.date_of_birth : null}`
            }`,

            age: `${
              govDetails.age
                ? govDetails.age
                : `${
                    details.result.age !== null && details.result.age !== undefined
                      ? details.result.age
                      : null
                  }`
            }`,

            gender: `${
              govDetails.gender
                ? govDetails.gender
                : `${details.result.gender ? details.result.gender : null}`
            }`,

            fathersName: `${
              govDetails.rln_name
                ? govDetails.rln_name
                : `${details.result.fathers_name ? details.result.fathers_name : null}`
            }`,

            district: `${
              govDetails.district
                ? govDetails.district
                : `${details.result.district ? details.result.district : null}`
            }`,

            parlimentaryConstituency: `${
              govDetails.state
                ? govDetails.state
                : `${details.result.state ? details.result.state : null}`
            }`,

            pollingStation: `${govDetails.ps_name ? govDetails.ps_name : null}`,

            address: `${details.result.address ? details.result.address : null}`
          };
          let matchedInformation = {
            voterNumber: `${
              details.result.id_number
                ? details.matchedInformation
                  ? details.matchedInformation.ocr_id_match !== null &&
                    details.matchedInformation.ocr_id_match !== undefined
                    ? details.matchedInformation.ocr_id_match
                    : govDetails.id_number
                    ? true
                    : null
                  : govDetails.id_number
                  ? true
                  : null
                : govDetails.id_number
                ? true
                : null
            }`,

            name: `${
              details.result.name_on_card
                ? details.matchedInformation
                  ? details.matchedInformation.name_match !== null &&
                    details.matchedInformation.name_match !== undefined
                    ? details.matchedInformation.name_match > 95
                    : govDetails.name_on_card
                    ? true
                    : null
                  : govDetails.name_on_card
                  ? true
                  : null
                : govDetails.name_on_card
                ? true
                : null
            }`,

            dateOfBirth: `${
              details.result.date_of_birth
                ? details.matchedInformation
                  ? details.matchedInformation.dob_match !== null &&
                    details.matchedInformation.dob_match !== undefined
                    ? details.matchedInformation.dob_match
                    : govDetails.dob
                    ? true
                    : null
                  : govDetails.dob
                  ? true
                  : null
                : govDetails.dob
                ? true
                : null
            }`,

            age: `${
              details.result.age
                ? details.matchedInformation
                  ? details.matchedInformation.age_match !== null &&
                    details.matchedInformation.age_match !== undefined
                    ? details.matchedInformation.age_match
                    : govDetails.age
                    ? true
                    : null
                  : govDetails.age
                  ? true
                  : null
                : govDetails.age
                ? true
                : null
            }`,

            gender: `${
              details.result.gender
                ? details.matchedInformation
                  ? details.matchedInformation.gender !== null &&
                    details.matchedInformation.gender !== undefined
                    ? true
                    : govDetails.gender
                    ? true
                    : null
                  : govDetails.gender
                  ? true
                  : null
                : govDetails.gender
                ? true
                : null
            }`,

            fathersName: `${
              details.result.father_name
                ? details.matchedInformation
                  ? details.matchedInformation.father_name_match !== null &&
                    details.matchedInformation.father_name_match !== undefined
                    ? details.matchedInformation.father_name_match > 95
                    : govDetails.rln_name
                    ? true
                    : null
                  : govDetails.rln_name
                  ? true
                  : null
                : govDetails.rln_name
                ? true
                : null
            }`,

            district: `${govDetails.district ? true : null}`,

            parlimentaryConstituency: `${govDetails.state ? true : null}`,

            pollingStation: `${govDetails.ps_name ? true : null}`,

            address: `${
              details.result.address
                ? details.matchedInformation
                  ? details.matchedInformation.street_address_match !== null &&
                    details.matchedInformation.street_address_match !== undefined
                    ? details.matchedInformation.street_address_match > 75
                    : null
                  : null
                : null
            }`
          };
          this.setState({
            error: details.matchedInformation
              ? details.matchedInformation.message
                ? details.matchedInformation.message.toLowerCase().includes('error')
                  ? details.matchedInformation.message
                  : false
                : false
              : false,
            details: detailsInformation,
            matchedInformation: matchedInformation,
            isFaceMatched: isFaceMatched
          });
          this.setStatus(docType, detailsInformation, govDetails, matchedInformation);
          this.setPersonName(personName, detailsInformation);
          this.setDocuments(details.document1, details.document2);
        } else {
          this.setState({
            isData: false,
            date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
          });
        }
        break;
      }
      default: {
        this.setState({
          isData: false,
          date: moment().utcOffset('+05:30').format('D MMM YYYY, hh:mm A')
        });
        break;
      }
    }
  };

  setStatus = (docType, detailsInformation, govDetails, matchedInformation) => {
    switch (docType) {
      case 'Aadhaar Card': {
        this.setState({
          verfiedStatus: `${
            matchedInformation.aadhaarNumber === 'false' ||
            detailsInformation.faceMatch === 'Failed'
              ? 'failed'
              : `${
                  matchedInformation.name === 'false' ||
                  matchedInformation.dateOfBirth === 'false' ||
                  matchedInformation.age === 'false' ||
                  matchedInformation.gender === 'false' ||
                  matchedInformation.address === 'false' ||
                  matchedInformation.fathersName === 'false' ||
                  matchedInformation.district === 'false' ||
                  matchedInformation.state === 'false' ||
                  matchedInformation.pincode === 'false' ||
                  matchedInformation.mobileNumber === 'false'
                    ? 'unverified'
                    : 'verified'
                }`
          }`,
          isInfoUnavailable: `${govDetails ? 'false' : 'true'}`,
          isMisMatch: `${
            matchedInformation.aadhaarNumber === 'false' ||
            matchedInformation.name === 'false' ||
            matchedInformation.dateOfBirth === 'false' ||
            matchedInformation.age === 'false' ||
            matchedInformation.gender === 'false' ||
            matchedInformation.address === 'false' ||
            matchedInformation.fathersName === 'false'
          }`,
          isIdMismatch: `${matchedInformation.aadhaarNumber === 'false' ? false : true}`
        });
        break;
      }
      case 'PAN Card': {
        this.setState({
          verfiedStatus: `${
            matchedInformation.panNumber === 'false' || detailsInformation.faceMatch === 'Failed'
              ? 'failed'
              : `${
                  matchedInformation.name === 'false' ||
                  matchedInformation.dateOfBirth === 'false' ||
                  matchedInformation.panNumber === 'false'
                    ? 'unverified'
                    : 'verified'
                }`
          }`,
          isInfoUnavailable: `${
            detailsInformation.age !== 'null' ||
            detailsInformation.fathersName !== 'null' ||
            detailsInformation.panType !== 'null'
          }`,
          isMisMatch: `${
            matchedInformation.panNumber === 'false' ||
            matchedInformation.name === 'false' ||
            matchedInformation.dateOfBirth === 'false'
          }`,
          isIdMismatch: `${matchedInformation.panNumber === 'false' ? false : true}`
        });
        break;
      }
      case "Driver's License": {
        this.setState({
          verfiedStatus: `${
            matchedInformation.dlNumber === 'false' || detailsInformation.faceMatch === 'Failed'
              ? 'failed'
              : `${
                  matchedInformation.name === 'false' ||
                  matchedInformation.dateOfBirth === 'false' ||
                  matchedInformation.fathersName === 'false' ||
                  matchedInformation.address === 'false' ||
                  matchedInformation.status === 'false' ||
                  matchedInformation.dlNumber === 'false'
                    ? 'unverified'
                    : 'verified'
                }`
          }`,
          isInfoUnavailable: `${
            (govDetails.relatives_name === 'null' && detailsInformation.fathersName !== 'null') ||
            (govDetails.address === 'null' && detailsInformation.address !== 'null') ||
            detailsInformation.pincode !== 'null' ||
            (govDetails.cov_details === 'null' && detailsInformation.vehicleClass !== 'null')
          }`,
          isMisMatch: `${
            matchedInformation.dlNumber === 'false' ||
            matchedInformation.name === 'false' ||
            matchedInformation.dateOfBirth === 'false' ||
            matchedInformation.status === 'false'
          }`,
          isIdMismatch: `${matchedInformation.dlNumber === 'false' ? false : true}`
        });
        break;
      }
      case 'Voter ID': {
        this.setState({
          verfiedStatus: `${
            matchedInformation.voterNumber === 'false' || detailsInformation.faceMatch === 'Failed'
              ? 'failed'
              : `${
                  matchedInformation.name === 'false' ||
                  matchedInformation.gender === 'false' ||
                  matchedInformation.fathersName === 'false' ||
                  matchedInformation.address === 'false' ||
                  matchedInformation.voterNumber === 'false'
                    ? 'unverified'
                    : 'verified'
                }`
          }`,
          isInfoUnavailable: `${
            detailsInformation.age !== 'null' ||
            (govDetails.district === 'null' && detailsInformation.district !== 'null') ||
            (govDetails.state === 'null' &&
              detailsInformation.parlimentaryConstituency !== 'null') ||
            detailsInformation.address !== 'null'
          }`,
          isMisMatch: `${
            matchedInformation.voterNumber === 'false' ||
            matchedInformation.name === 'false' ||
            matchedInformation.gender === 'false' ||
            matchedInformation.fathersName === 'false'
          }`,
          isIdMismatch: `${matchedInformation.voterNumber === 'false' ? false : true}`
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  setPersonName = (personName, detailsInformation) => {
    let name = `${
      detailsInformation.name && detailsInformation.name !== 'null'
        ? detailsInformation.name
        : personName
    }`;
    this.setState({
      personName: name
    });
  };

  setSelfieUrl = (selfieUrl) => {
    if (selfieUrl) {
        this.setState({
          selfieUrl: selfieUrl,
          selfieLoading: false
        });
    } else {
      this.setState({
        selfieUrl: require('../Assets/report-images/user-icon.png').default,
        selfieLoading: false
      });
    }
  };

  setDocuments = (document1, document2) => {
    if (document1) {
        this.setState({
          document1: document1,
          loading1: false
        });
    } else {
      this.setState({
        loading1: false
      });
    }
    if (document2) {
        this.setState({
          document2: document2,
          loading2: false
        });
    } else {
      this.setState({
        loading2: false
      });
    }
  };

  render() {
    return (
      <div>
        {this.state.isData === true &&
        !this.state.selfieLoading &&
        !this.state.loading1 &&
        !this.state.loading2 ? (
          <div>
            {this.state.docType === 'courtCheck' ? (
              <div>
                <ReportContainer
                  pageNo={1}
                  totalPages={this.state.noOfCases < 3 ? '2' : `${this.state.noOfCases / 3 + 2}`}
                  date={this.state.date}
                  docType={this.state.docType}
                />
                <ReportContainer
                  pageNo={2}
                  totalPages={this.state.noOfCases < 3 ? '2' : `${this.state.noOfCases / 3 + 2}`}
                  date={this.state.date}
                  docType={this.state.docType}
                  personName={this.state.personName}
                  fathersName={this.state.fathersName}
                  address={this.state.address}
                  noOfCases={this.state.noOfCases}
                  cases={this.state.cases}
                />
                {this.state.noOfCases > 2 ? (
                  this.state.cases.map((value, index) => {
                    if (index % 3 === 2) {
                      return (
                        <ReportContainer
                          key={index}
                          pageNo={Math.floor(index / 3) + 3}
                          totalPages={
                            this.state.noOfCases < 3 ? '2' : `${this.state.noOfCases / 3 + 2}`
                          }
                          date={this.state.date}
                          docType={this.state.docType}
                          noOfCases={this.state.noOfCases}
                          cases={this.state.cases}
                        />
                      );
                    }
                  })
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              <div>
                <ReportContainer
                  pageNo={'1'}
                  totalPages={this.state.isFaceMatched === 'true' ? '4' : '3'}
                  date={this.state.date}
                  selfieUrl={this.state.selfieUrl}
                  verfiedStatus={this.state.verfiedStatus}
                  personName={this.state.personName}
                  docType={this.state.docType}
                  isIdMismatch={this.state.isIdMismatch}
                  isFaceMatched={this.state.isFaceMatched}
                  details={this.state.details}
                  matchedInformation={this.state.matchedInformation}
                  isMisMatch={this.state.isMisMatch}
                  isInfoUnavailable={this.state.isInfoUnavailable}
                  error={this.state.error}
                />
                <ReportContainer
                  pageNo={'2'}
                  totalPages={this.state.isFaceMatched === 'true' ? '4' : '3'}
                  date={this.state.date}
                  selfieUrl={this.state.selfieUrl}
                  verfiedStatus={this.state.verfiedStatus}
                  personName={this.state.personName}
                  details={this.state.details}
                  docType={this.state.docType}
                />
                {this.state.document1 ? (
                  <ReportContainer
                    pageNo={'3'}
                    totalPages={this.state.isFaceMatched === 'true' ? '4' : '3'}
                    date={this.state.date}
                    document1={this.state.document1}
                    document2={this.state.document2}
                  />
                ) : (
                  <div></div>
                )}
                {this.state.isFaceMatched === 'true' ? (
                  <ReportContainer
                    pageNo={'4'}
                    totalPages={this.state.isFaceMatched === 'true' ? '4' : '3'}
                    date={this.state.date}
                    document1={this.state.selfieUrl}
                  />
                ) : (
                  <div></div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div>
            {this.state.isData === false ? (
              <ReportContainer
                pageNo={'1'}
                totalPages={'1'}
                date={this.state.date}
                isData={this.state.isData}
              />
            ) : (
              <div></div>
            )}
          </div>
        )}
      </div>
    );
  }
}
